import React from "react";
import { Fragment } from "react";
import DateFns from "date-fns";
import { Table } from "react-bootstrap";

const TableRow = ({ data }) => {
  console.log(data);
  const isDateFormat = (fromdata, todata) => {
    return `${DateFns.format(fromdata, "DD/MM/YYYY")}-${DateFns.format(
      todata,
      "DD/MM/YYYY"
    )} `;
  };

  const rows = data.map((item) => (
    <>
      {/* <Table bordered style={{"border-style": "solid"}}>
          <thead>

          <tr>
            <th><h6>Qualification</h6></th>
            <th><h6>Board/University</h6></th>
            <th><h6>Year</h6></th>
            <th><h6>Percentage</h6></th>

          </tr>
          </thead> */}
     
        <tr >
          <td >
            <p>{item.candQual}</p>
          </td>
          <td>
            {" "}
            <p>{item.instiName}</p>
          </td>
          <td>
            {" "}
            <p>{isDateFormat(item.startDate, item.endDate)}</p>
          </td>
          <td>
            {" "}
            <p>{item.grade}</p>
          </td>
        </tr>
  
    </>
  ));

  return (
    <>
      <Table bordered style={{ "border-style": "solid" }}>
        <thead>
          <tr>
            <th>
              <h6>Qualification</h6>
            </th>
            <th>
              <h6>Board/University</h6>
            </th>
            <th>
              <h6>Year</h6>
            </th>
            <th>
              <h6>Percentage/Grade</h6>
            </th>
          </tr>
        </thead>
        <tbody>
          <Fragment>{rows}</Fragment>
        </tbody>
      </Table>
    </>
  );
};

export default TableRow;
